function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import ContextMenu from "./ContextMenu.js";
import ContextActionUtils from "./ContextActionUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Put at your root container, any contextmenu events that are unhandled in the root container will be handled by this
 */
class ContextMenuRoot extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "openMenu", void 0);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.openMenu = /*#__PURE__*/React.createRef();
    this.state = {
      actions: null,
      left: 0,
      top: 0
    };
  }
  componentDidMount() {
    var _this$container$curre;
    if ((_this$container$curre = this.container.current) !== null && _this$container$curre !== void 0 && _this$container$curre.parentElement) {
      this.container.current.parentElement.addEventListener('contextmenu', this.handleContextMenu);
    }
  }
  componentWillUnmount() {
    var _this$container$curre2;
    if ((_this$container$curre2 = this.container.current) !== null && _this$container$curre2 !== void 0 && _this$container$curre2.parentElement) {
      this.container.current.parentElement.removeEventListener('contextmenu', this.handleContextMenu);
    }
  }
  handleContextMenu(e) {
    if (!this.container.current) {
      return;
    }
    var parentRect = this.container.current.getBoundingClientRect();
    var top = e.clientY - parentRect.top;
    var left = e.clientX - parentRect.left;
    var actions = this.state.actions;

    // Context menu is open and user clicked on the context-root blocking layer
    // Mac and Linux appear to trigger contextmenu events on mousedown vs. mouseup on Windows
    // Mouseup on Windows triggers blur before contextmenu which effectively does what this path does
    if (actions != null && e.target === this.container.current) {
      // re-emit right clicks that hit the context-root blocking layer
      // while we already have a custom context menu open
      e.preventDefault();

      // Set actions to null removes the menu
      // That allows a new menu to be opened on a different element so initial position is set properly
      // Otherwise the instance of this menu may be reused
      // A new contextmenu event is triggered on the element at the location the user clicked on the blocking layer
      this.setState({
        actions: null
      }, () => {
        var element = document.elementFromPoint(left, top); // x y

        var mouseEvent = new MouseEvent('contextmenu', {
          clientX: e.clientX,
          clientY: e.clientY,
          bubbles: true,
          cancelable: true
        });
        element === null || element === void 0 || element.dispatchEvent(mouseEvent);
      });
      return;
    }
    if (!ContextActionUtils.isContextActionEvent(e)) {
      // Open native menu if no custom context actions
      return;
    }
    if (e.metaKey || e.ctrlKey) {
      // debug escape hatch to native menu
      return;
    }
    var contextActions = ContextActionUtils.getMenuItems(e.contextActions);
    if (contextActions.length === 0) {
      // No actions after filtering. Use native menu
      return;
    }

    // new clicks, set actions
    e.preventDefault();
    this.setState({
      actions: contextActions,
      top,
      left
    });
  }
  handleMenuClose(menu) {
    if (menu === this.openMenu.current) {
      this.setState({
        actions: null
      });
    }
  }
  render() {
    var menu = null;
    var dataTestId = this.props['data-testid'];
    var _this$state = this.state,
      actions = _this$state.actions,
      top = _this$state.top,
      left = _this$state.left;
    if (actions) {
      menu = /*#__PURE__*/_jsx(ContextMenu, {
        ref: this.openMenu,
        actions: actions,
        onMenuClosed: this.handleMenuClose,
        top: top,
        left: left,
        updatePosition: (verifiedTop, verifiedLeft) => {
          this.setState({
            top: verifiedTop,
            left: verifiedLeft
          });
        },
        "data-testid": dataTestId
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: classNames('context-menu-root', {
        active: actions
      }),
      ref: this.container,
      children: menu
    });
  }
}
export default ContextMenuRoot;
//# sourceMappingURL=ContextMenuRoot.js.map